import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Select, MenuItem, FormControl, Divider } from "@mui/material";
import { ArrowDropDownRounded } from "@mui/icons-material";

const getMenuItems = (accounts, type) =>
    accounts.length
        ? [
              <StyledDivider key={`${type}-divider`} />,
              <GroupHeader key={`${type}-accounts-header`} id="label" disabled>
                  {type} accounts
              </GroupHeader>,
              accounts.map((opt, i) => (
                  <MenuItem key={`${opt.value}-${i}`} value={opt.value}>
                      {opt.display}
                  </MenuItem>
              ))
          ]
        : [null];

export function SelectionBoxAccounts({ handleSelect, value, options }) {
    const allAccountsOption = options.find(opt => opt.display === "All accounts");
    const activeAccounts = options.filter(
        opt => opt.status !== "Closed" && opt.display !== "All accounts"
    );
    const closedAccounts = options.filter(opt => opt.status === "Closed");

    const accountsList = [
        ...getMenuItems(activeAccounts, "Active"),
        ...getMenuItems(closedAccounts, "Closed")
    ];

    return (
        <Container>
            <StyledFormControl variant="outlined">
                <Select
                    onChange={handleSelect}
                    value={value}
                    IconComponent={ArrowDropDownRounded}
                    inputProps={{
                        "aria-label": "select an account"
                    }}
                >
                    {options.length === 0 ? (
                        <MenuItem value={value} disabled>
                            Loading account list..
                        </MenuItem>
                    ) : (
                        [
                            <MenuItem key="select-acc-placeholder" value="default" disabled>
                                Select an account..
                            </MenuItem>,

                            allAccountsOption ? (
                                <MenuItem
                                    key={`${allAccountsOption.value}`}
                                    value={allAccountsOption.value}
                                >
                                    {allAccountsOption.display}
                                </MenuItem>
                            ) : null,

                            ...accountsList
                        ]
                    )}
                </Select>
            </StyledFormControl>
        </Container>
    );
}

const StyledDivider = styled(Divider)`
    && {
        background-color: ${props => props.theme.primary};
    }
`;

const GroupHeader = styled(MenuItem)`
    && {
        color: ${props => props.theme.primary};
        opacity: 1 !important;
    }
`;

const Container = styled.div`
    width: 100%;
    max-width: 300px;
`;

const StyledFormControl = styled(FormControl)`
    width: 100%;
    background: white;
    border-radius: 5px;
`;

SelectionBoxAccounts.propTypes = {
    value: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            display: PropTypes.string
        })
    ),
    handleSelect: PropTypes.func
};
